import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { auth } from './plugins/firebase'
import configMap from './plugins/googleMaps'
import VueApexCharts from 'vue-apexcharts'
import * as VueGoogleMaps from 'vue2-google-maps'
import JsonCSV from 'vue-json-csv'


Vue.component('apexchart', VueApexCharts)
Vue.component('downloadCsv', JsonCSV)
Vue.use(VueGoogleMaps, configMap)

Vue.config.productionTip = false

let app

auth.onAuthStateChanged(async (user) => {

    if (!app) {
        app = new Vue({
            router,
            store,
            vuetify,
            render: (h) => h(App),
        })
    }
    try {
        await store.dispatch('user/checkLogin')
        await store.dispatch('meters/setCollectionDb')
        await store.dispatch('schedules/setCollectionDb')
        await store.dispatch('meters/updateMeterFromApi')
        if(!window.refreshLastReadings && auth.currentUser)
            window.refreshLastReadings = setInterval(async () => {
                if(window.location.href === 'http://localhost:8080/#/map/general' || window.location.href ==='http://localhost:8080/#/'){
                    await store.dispatch('meters/lastReadings');
                    console.log('GET LAST')
                }
            }, 1000 * 60)
        app.$mount('#app');

    } catch (error) {
        console.log('error')
    }
    
})
